import React from "react";

function formatString(str) {
  if (typeof str !== "string" || !str.trim()) return "—";
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

const PatientDetailsHeader = ({ patientDetails, sessionType }) => {
  // Always render; use safe fallbacks even if patientDetails is null/undefined
  const data = patientDetails ?? {};

  const name = data?.name ?? "—";
  const age =
    data?.age != null && data?.age !== "" ? `${data.age} yrs` : "—";
  const gender = data?.gender
    ? String(data.gender).charAt(0).toUpperCase() +
      String(data.gender).slice(1).toLowerCase()
    : "—";

  const type =
    sessionType ??
    data?.sessionType ??
    data?.session_type ??
    "—";

  const patientInfo = [
    { label: "Name", value: name },
    { label: "Age", value: age },
    { label: "Gender", value: gender },
    { label: "Session Type", value: formatString(type) },
  ];

  return (
    <div
      className="patient-details-header bg-white rounded-xl p-4 shadow-sm border border-gray-100"
      style={{
        minHeight: "142px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
      }}
      data-testid="patient-details-header"
    >
      {/* Header */}
      <div className="flex items-center gap-3 pb-3 mb-3 border-b border-gray-200">
        <div className="flex items-center justify-center w-7 h-7 bg-blue-100 rounded-full">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-blue-600"
          >
            <path
              d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
              fill="currentColor"
            />
            <path
              d="M12 14C7.58172 14 4 17.5817 4 22H20C20 17.5817 16.4183 14 12 14Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <h3
          className="text-gray-800 font-semibold text-[14px] tracking-wide uppercase m-0"
          style={{ letterSpacing: "0.5px" }}
        >
          Patient Details
        </h3>
      </div>

      {/* Patient Information Grid */}
      <div className="grid grid-cols-2 gap-4">
        {patientInfo.map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <span className="text-gray-600 text-[12px] font-medium">
              {item.label}:
            </span>
            <span className="text-gray-800 text-[13px] font-semibold">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientDetailsHeader;
